module.exports = __webpack_public_path__ + "img/icon_eye_close.25d74524.svg";